import request from '@/config/axios'
import type { HotelRoomType } from '@/api/merchant/hotel'

const BASE = '/hotel/platform/room-type'

export interface PlatformRoomTypeHotelOption {
  shopId: string | number
  shopName: string
  operationMode?: string
}

export const getPlatformHotelOptions = () =>
  request.get<PlatformRoomTypeHotelOption[]>({ url: `${BASE}/hotel-options` })

export const getPlatformRoomTypes = (shopId: string | number) =>
  request.get<HotelRoomType[]>({ url: `${BASE}/list`, params: { shopId } })

export const auditPlatformRoomType = (data: {
  shopId: string | number
  roomTypeId: string | number
  approved: boolean
  remark: string
}) => request.post<boolean>({ url: `${BASE}/audit`, data })
